import { useDispatch } from 'react-redux'
import { AppDispatch, useRoutes } from '../../../store'
import Table from '../../common/Table'
import Button from '@mui/material/Button'
import { useAdPodsSelector, usePageParamsFilteredSelector, useUser } from '../../../utils'
import Wrapper from '../../common/Wrapper'
import { getConfig } from './tableConfig'
import { useState } from 'react'
import { AdCreativeWithUrls, AdPod, Role, type User } from 'common/api/v1/types'
import CommonActions from './CommonActions'
import { useNavigate } from 'react-router'
import { MissingContent } from '../../common/MissingContent'

export const canEditAdPod = (user: User, createdBy: AdPod['createdBy']) => {
  return (user.role === Role.admin && user.group === createdBy) || user.role === Role.super
}

export const AdPodList = () => {
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const [selected, setSelected] = useState<Array<AdCreativeWithUrls['id']>>([])
  const user = useUser()
  const routes = useRoutes()

  const { adPods, total, loading } = usePageParamsFilteredSelector(useAdPodsSelector)

  return (
    <>
      <Wrapper
        name={['Ad Insertion', 'Ad Pods']}
        actions={
          <Button id={'button-add'} variant="contained" color="primary" onClick={() => navigate(routes.adPodsNew())}>
            Add
          </Button>
        }
      >
        <CommonActions selected={selected} setSelected={setSelected} adPods={adPods} user={user} />
        <Table
          id={'ad-pods-table'}
          emptyMessageComponent={<MissingContent message="No ad pods" buttonText="Add" url={routes.adPodsNew()} />}
          data={adPods}
          pagination={{
            total: total,
            useUrlSearchParams: true,
          }}
          config={getConfig({
            adPods,
            dispatch,
            selected,
            handleSelect: (id: string) => {
              setSelected((prev) => (prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]))
            },
            handleSelectAll: () => {
              setSelected((prev) => (prev.length === adPods.length ? [] : adPods.map((adPod) => adPod.id)))
            },
            user,
            routes,
          })}
          rowProps={({ id, createdBy }) => {
            const isItemSelected = Boolean(id && selected.includes(id))
            return {
              onDoubleClick: () => (canEditAdPod(user, createdBy) ? void navigate(routes.adPodsUpdate({ id })) : null),
              'aria-checked': isItemSelected,
              tabIndex: -1,
              selected: isItemSelected,
            }
          }}
          pending={loading}
        />
      </Wrapper>
    </>
  )
}
